import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslationEnum } from '../shared/enums/translation-enum';
import { FormV2ServiceService } from '../form-v2/form-v2-service.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TresciService } from '../tresci.service';
import { UserService } from '../user.service';
import { BehaviorSubject } from 'rxjs';
import { KindOper } from '../shared/enums/kind-oper-enum';
import { Parameter } from '../shared/models/form-model/models/form-controlls.model';
import { FormDataSend } from '../form-v2/form-model/FormDataSend';
import { EditForm } from '../shared/models/form/edit-form.model';

declare const window: any;
@Component({
  selector: 'app-form-v2-preview',
  templateUrl: './form-v2-preview.component.html',
  styleUrls: ['./form-v2-preview.component.scss']
})
export class FormV2PreviewComponent implements OnInit,OnDestroy {

  public TranslationEnum = TranslationEnum;
  TranslationLoaded: any;
  culture: any;
  wczytywanie: boolean;
  kindOper: any;
  SystemName: string;
  produktPrefix: any;
  IsTrader: any;
  orderId: any;
  zakladka: number = 0;
  Parametry: EditForm;
  DeliveryMethods: any;
  ContractorAddresses: any = [];
  modul = 0;
  modyly: any[] = [];
  naglowek: any[] = [];
  pozycja: any[] = [];

  podglad_poz = false;
  edytowany_mod: any;
  edytowana_poz: any;


    
  constructor(private formService: FormV2ServiceService,public dialog: MatDialog,private activatedRoute: ActivatedRoute,
    private translateService: TranslateService, public tresci: TresciService, public user: UserService, private router: Router) {

      this.activatedRoute.params.subscribe((params) => {
        localStorage.site = params.system;
        window['site'] = params.system;
        tresci.wczytaj_tresci_tlumaczen2(window['culture'], params.system);
        this.TranslationLoaded = new BehaviorSubject(false);
    
        this.translateService.reloadLang(this.translateService.currentLang).subscribe((x) => this.TranslationLoaded.next(true));
      });
    }

  ngOnInit(): void {
    
    // console.log(this.user);
    this.culture = window['culture'];
    this.wczytywanie = true;
    this.activatedRoute.params.subscribe((params) => {
   
      this.kindOper = KindOper[params.kindOper as keyof typeof KindOper];
      this.SystemName = 'system_' + params.system.toLowerCase();
      localStorage.site = params.system;
      window['site'] = params.system;
      this.produktPrefix = params.system;
      this.orderId = params.id;
      //this.formService.ProductPrefix = params.system;
      //window['site'] = this.formService.ProductPrefix;
      // this.TranslationLoaded = new BehaviorSubject(false);
      if(window['culture'] != null && window['culture'] != ''){
        this.translateService.currentLang = window['culture']; 
      }
     
      this.culture = this.culture;
      this.IsTrader = this.IsTrader;


      this.formService.getDeliveryAddresses().
      subscribe((data) => {
        // console.log(data, 'x');
        this.DeliveryMethods = data.DeliveryMethods;
        this.ContractorAddresses = data.ContractorAddresses;
        
        
      })

      this.formService.getOrderParameters(this.orderId, true).
      subscribe((data) => {
        this.Parametry = data;
         console.log(this.Parametry);
        this.modyly = [];
        this.Parametry.Parameters.forEach(p => {
          if(p.Module > this.modyly.length){
            this.modyly.push(1);
          }
        });
        this.GetNg();
        this.wczytywanie = false;
      });
     
    });


    
  }

  getFileInfo(key: string){
    return 'plik_info_' + key.toLocaleLowerCase() + "_" + localStorage.site + "_" + this.culture;
  }
  WyjdzZEdycji(poz: any){
    this.podglad_poz = false;
  }
  EdytujPozycje(mod: any, poz: any){
    this.edytowany_mod = mod;
    this.edytowana_poz = poz;
    this.podglad_poz = true;
  }
  czyZawiera(key: string | string[]){
    var zawiera = false;
    if(key.includes('suma_')){
      zawiera = true;
    }
    if(key.includes('min_')){
      zawiera = true;
    }
    if(key.includes('max_')){
      zawiera = true;
    }

    return zawiera;
  }
  returnToOrders(): void {
      this.router.navigate(['Orders']);
  }
  GetNg(){
    this.naglowek = [];
    this.pozycja = [];
    this.Parametry.Parameters.forEach(p => {
      if(p.Module == this.modul + 1 && p.Type == 2){
        if(!this.czyZawiera(p.Key) && p.ControlName!= 'Hidden' && p.ControlName != 'Label' && p.GenDisplayValue != null && p.GenDisplayValue != ''){
          if(this.naglowek.findIndex(x => x == p.Key) < 0){
            this.naglowek.push(p.Key);
          }
          if(p.Position > this.pozycja.length){
            this.pozycja.push('');
          }
        }
      }
    });
  }
  GetLangValue(p: Parameter){
    var result:string = null;
    if(this.Parametry.Languages != null){
        var t = this.Parametry.Languages.find(x => x.Culture.toLowerCase() == window['culture'].toLowerCase() && x.TranslateCode == p.TranslateCode && x.Value == p.Value);
        if(t != null){
          result = t.DisplayedValue;
        }
    } 

    if(result == null){
      switch (this.culture) {
        case 'pl':
          result = p.DisplayValuePl;
          break;
        case 'de':
          result = p.DisplayValueDe;
          break;
        case 'en':
          result = p.DisplayValueEn;
          break;
        case 'fr':
          result = p.DisplayValueFr;
          break;
        case 'fr':
          result = p.DisplayValueCs;
          break;
        case 'it':
          result = p.DisplayValueIt;
          break;
        default:
          result = p.GenDisplayValue;
          break; 
      }
    }
    
    if(result != null){
      return result;
    } else {
      return p.GenDisplayValue;
    }
    
  }
  GetValue(pozycja: number, key: any) {
    var poz;
    this.Parametry.Parameters.forEach(p => {
      if(p.Module == this.modul + 1 && p.Position == pozycja + 1 && p.Key == key){
            poz =this.GetLangValue(p);
      }
    });
    return poz;
  }
  
  ngOnDestroy(): void {
    // console.log("destroy");
    localStorage.site = "stale";
    window['site'] = "stale";
  }

  ZmienModul(numer: number){
    this.modul = numer;
    this.GetNg();
  }

}
